import React from 'react';
import { useDatabase } from "../../context/DatabaseContext";

const Profile = () => {
    const { notModifiedList } = useDatabase()
    return (
        <div>
            {console.log(notModifiedList)}
        </div>
    );
};

export default Profile;